module.exports = __webpack_public_path__ + "img/concrete-hole-decal-01.f2b5a515.png";